import React from 'react';
import { graphql } from 'gatsby';
import styled, { css } from 'styled-components';
import Layout from 'gatsby-theme-core/src/layout/layout';
import Container from 'gatsby-theme-core/src/components/container';
import Content from 'gatsby-theme-core/src/components/content';
import Image from 'gatsby-theme-core/src/components/image';
import PageImage from 'gatsby-theme-core/src/components/page-image';
import Form from 'gatsby-theme-forms/src/components/form';
import Breadcrumbs from '../../components/breadcrumbs';

export const pageQuery = graphql`
  query EaPageById($id: ID!) {
    strapi {
      page(id: $id) {
        id
        title
        content
        form {
          ...StrapiForm
        }
        image {
          url
          height
          width
          name
          imageFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, quality: 100, placeholder: BLURRED)
            }
          }
        }
        contentImage {
          url
          height
          width
          imageFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
            }
          }
        }
        ...PagesPageHead
      }
    }
  }
`;

const Page = ({ data }) => {
  const { page } = data.strapi;
  const { contentImage } = page;
  const noColumns = !contentImage || !page.content;
  return (
    <>
      <PageImage darker image={page.image}>
        <StyledContainer>
          <Title>{page.title}</Title>
        </StyledContainer>
      </PageImage>
      <Container>
        <Breadcrumbs self={{ title: page.title }} />
        <Grid columns={!noColumns} columnWidth={contentImage?.width}>
          {contentImage && (
            <div>
              <ImageWrapper width={contentImage?.width}>
                <Image image={contentImage} />
              </ImageWrapper>
            </div>
          )}
          {page?.content && (
            <Content $content={page?.content} />
          )}
        </Grid>
        {page.form && (
          <Grid columns={false}>
            <Form {...page.form} />
          </Grid>
        )}
      </Container>
    </>
  );
};

const Title = styled.h3`
  font-size: 1.5rem;
  text-transform: uppercase;
  font-weight: bold;
  color: white;
`;
const ImageWrapper = styled.div`
  max-width: ${({ width }) => (width ? `${width}px` : 'auto')};
`;
const StyledContainer = styled(Container)`
  height: 10rem;
  display: flex;
  align-items: center;
`;
const Grid = styled.div`
  display: grid;
  grid-auto-rows: auto;
  padding: 2rem 0;
  ${({ columns }) => (columns
    ? css`
      grid-template-columns: 1fr;
      @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
        grid-template-columns: 1fr 1fr;
      }
    `
    : css`
      grid-template-columns: 1fr;
    `
  )}
  grid-gap: ${({ theme }) => theme.grid.columnGap};
`;

export default (props) => (
  <Layout {...props.data.strapi.page}>
    <Page {...props} />
  </Layout>
);
